import { Drawer } from '../admin/components/Drawer';
import { CustomerFile } from './CustomerFile';

type CustomerFileDrawerProps = {
  customer: { customerId: string; name: string } | null;
  onClose: () => void;
};

/**
 * The ficha opened from a roster or an agenda, where the person tapping is
 * often the coach or the barber, not the owner: same file, no numbers.
 */
export function CustomerFileDrawer({ customer, onClose }: CustomerFileDrawerProps) {
  return (
    <Drawer open={Boolean(customer)} title={customer?.name ?? ''} onClose={onClose}>
      {customer ? <CustomerFile key={customer.customerId} customerId={customer.customerId} /> : null}
    </Drawer>
  );
}
